import { objectExtensions } from '@felicity/primitives';

import ej2CsCZ from '@syncfusion/ej2-locale/src/cs.json';
import ej2DaDK from '@syncfusion/ej2-locale/src/da.json';
import ej2DeDE from '@syncfusion/ej2-locale/src/de.json';
import ej2EnGB from '@syncfusion/ej2-locale/src/en-GB.json';
import ej2EsES from '@syncfusion/ej2-locale/src/es.json';
import ej2FiFI from '@syncfusion/ej2-locale/src/fi.json';
import ej2FrFR from '@syncfusion/ej2-locale/src/fr.json';
import ej2HrHR from '@syncfusion/ej2-locale/src/hr.json';
import ej2HuHU from '@syncfusion/ej2-locale/src/hu.json';
import ej2ItIT from '@syncfusion/ej2-locale/src/it.json';
import ej2NlNL from '@syncfusion/ej2-locale/src/nl.json';
import ej2PlPL from '@syncfusion/ej2-locale/src/pl.json';
import ej2PtPT from '@syncfusion/ej2-locale/src/pt.json';
import ej2RoRO from '@syncfusion/ej2-locale/src/ro.json';
import ej2SkSK from '@syncfusion/ej2-locale/src/sk.json';
import ej2SvSE from '@syncfusion/ej2-locale/src/sv.json';

import { locales as dataManagementLocale } from '@felicity/data-management';
import { locales as standardsLocales } from '@felicity/standards';
import { locales as mcaLocales } from '@felicity/multi-criteria-analysis';
// import { locales as assessmentProjectLocale } from '@felicity/assessment-project';
import ej2SlSI from './ej2-locale.sl-SI.json';
import ej2MtMT from './ej2-locale.mt-MT.json';
import ej2LvLV from './ej2-locale.lv-LV.json';
import ej2LtLT from './ej2-locale.lt-LT.json';
import ej2GaIE from './ej2-locale.ga-IE.json';
import ej2EtEE from './ej2-locale.et-EE.json';
import ej2ElGR from './ej2-locale.el-GR.json';
import ej2BgBG from './ej2-locale.bg-BG.json';

import usersBgBG from './users/bg-BG.json';
import usersCsCZ from './users/cs-CZ.json';
import usersDaDK from './users/da-DK.json';
import usersDeDE from './users/de-DE.json';
import usersElGR from './users/el-GR.json';
import usersEnGB from './users/en-GB.json';
import usersEsES from './users/es-ES.json';
import usersEtEE from './users/et-EE.json';
import usersFiFI from './users/fi-FI.json';
import usersFrFR from './users/fr-FR.json';
import usersGaIE from './users/ga-IE.json';
import usersHrHR from './users/hr-HR.json';
import usersHuHU from './users/hu-HU.json';
import usersItIT from './users/it-IT.json';
import usersLtLT from './users/lt-LT.json';
import usersLvLV from './users/lv-LV.json';
import usersMtMT from './users/mt-MT.json';
import usersNlNL from './users/nl-NL.json';
import usersPlPL from './users/pl-PL.json';
import usersPtPT from './users/pt-PT.json';
import usersRoRO from './users/ro-RO.json';
import usersSkSK from './users/sk-SK.json';
import usersSlSI from './users/sl-SI.json';
import usersSvSE from './users/sv-SE.json';

const ej2Locale = {
    'bg-BG': ej2BgBG['bg-BG'],
    'cs-CZ': ej2CsCZ.cs,
    'da-DK': ej2DaDK.da,
    'de-DE': ej2DeDE.de,
    'el-GR': ej2ElGR['el-GR'],
    'en-GB': ej2EnGB['en-GB'],
    'es-ES': ej2EsES.es,
    'et-EE': ej2EtEE['et-EE'],
    'fi-FI': ej2FiFI.fi,
    'fr-FR': ej2FrFR.fr,
    'ga-IE': ej2GaIE['ga-IE'],
    'hr-HR': ej2HrHR.hr,
    'hu-HU': ej2HuHU.hu,
    'it-IT': ej2ItIT.it,
    'lt-LT': ej2LtLT['lt-LT'],
    'lv-LV': ej2LvLV['lv-LV'],
    'mt-MT': ej2MtMT['mt-MT'],
    'nl-NL': ej2NlNL.nl,
    'pl-PL': ej2PlPL.pl,
    'pt-PT': ej2PtPT.pt,
    'ro-RO': ej2RoRO.ro,
    'sk-SK': ej2SkSK.sk,
    'sl-SI': ej2SlSI['sl-SI'],
    'sv-SE': ej2SvSE.sv
  },

  usersLocale = {
    ...usersBgBG,
    ...usersCsCZ,
    ...usersDaDK,
    ...usersDeDE,
    ...usersElGR,
    ...usersEnGB,
    ...usersEsES,
    ...usersEtEE,
    ...usersFiFI,
    ...usersFrFR,
    ...usersGaIE,
    ...usersHrHR,
    ...usersHuHU,
    ...usersItIT,
    ...usersLtLT,
    ...usersLvLV,
    ...usersMtMT,
    ...usersNlNL,
    ...usersPlPL,
    ...usersPtPT,
    ...usersRoRO,
    ...usersSkSK,
    ...usersSlSI,
    ...usersSvSE
  },

  locale = Object.merge(
    {},
    ej2Locale,
    dataManagementLocale,
    usersLocale,
    standardsLocales,
    mcaLocales
  );

export default locale;
